import styled from 'styled-components'
export const Wrapper = styled.div`
  position: relative;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  .pageNumber {
    position: absolute;
    right: 5px;
    top: -25px;
    font-style: normal;
    font-size: ${({ theme }) => theme.fontSize.x6};
    letter-spacing: 0.75%;
    color: ${({ theme }) => theme.colors.black};
  }
  .information {
    color: red;
    margin-top: -25px;
  }
  .input_wrapper {
    margin: 40px 0;
  }

  .timeframe {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .data {
    font-style: normal;
    font-size: ${({ theme }) => theme.fontSize.x5};
    letter-spacing: 0.75%;
    color: ${({ theme }) => theme.colors.gray};
  }
  .data-title {
    font-style: bold;
    font-size: ${({ theme }) => theme.fontSize.x6};
    letter-spacing: 0.75%;
    color: ${({ theme }) => theme.colors.gray};
  }
  .top-data {
    margin-top: -17px;
  }
  .top {
    font-style: bold;
    font-size: ${({ theme }) => theme.fontSize.x2};
  }
  .delete-button {
    background-color: #ba0038;
    width: 202px;
    height: 58px;
  }
  .date-right {
    margin-top: -10px;
  }
  .mtop {
    margin-top: -45px;
  }
  .centerBg {
    text-align: center;
    justify-content: center;
    display: flex;
    align-items: center;
  }
  .top-form {
    margin-top: -10px;
  }
  .slider {
    width: 100%;
    border-radius: 11.87px;
    opacity: 30%;
    mix-blend-mode: normal;
    display: flex;
    align-items: center;
    margin-top: -15px;
    height: 5px;
    background-color: ${({ theme }) => theme.colors.gray};
  }
  .withdraw {
    position: absolute;
    right: 0px;
    top: -30px;
    font-style: normal;
    font-size: ${({ theme }) => theme.fontSize.x6};
    letter-spacing: 0.75%;
  }
  .time {
    border-radius: 20px;
    width: 119px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #6e7191;
    margin-right: 10px;
    font-style: normal;
    margin-bottom: 15px;
    background-color: white;
    font-size: ${({ theme }) => theme.fontSize.x2};
    letter-spacing: 0.75%;
    color: ${({ theme }) => theme.colors.gray};
  }
  .content {
    /* margin-top: 7px; */
    display: flex;
    flex-direction: column;
    height: 90vh;

    /* background: red; */
    justify-content: space-between;

    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      height: 600px;
      /* adjust the height so it fits for both android and ios devices */
    }
  }
  .form-group {
    margin-top: 50px;
  }
  .title {
    font-size: ${({ theme }) => theme.fontSize.xx1};
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: ${({ theme }) => theme.fontSize.xl};
    line-height: 140%;
    color: ${({ theme }) => theme.colors.navyBlue};
  }
  .red {
    background-color: red;
  }

  .desc {
    font-size: ${({ theme }) => theme.fontSize.x5};
    color: ${({ theme }) => theme.colors.dark};
    margin: 20px 0;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
  }
  .button {
    background-color: ${({ theme }) => theme.colors.secondPrimary};
  }
  .input {
    margin-top: 40px;
  }
  .input-two {
    margin-top: 5px;
  }
  .line {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 20px;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
  .target {
    width: 220px;
    background-color: ${({ theme }) => theme.colors.successGreen};
  }
  .targets {
    width: 400px;
    background-color: ${({ theme }) => theme.colors.successGreen};
  }
  .top {
    text-align: center;
    margin-top: 50px;
  }
  .frequency {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .details-amount {
    margin-left: 35px;
  }
  .reverse {
    margin-top: -20px;
    color: ${({ theme }) => theme.colors.primary};
  }
  .blur {
    background-color: #6e7191;
    opacity: 1;
  }
  .container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 22px;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.NeutralBlack};
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
    border-radius: 50%;
  }

  .container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  .container input:checked ~ .checkmark {
    background-color: #2196f3;
  }

  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }

  .container input:checked ~ .checkmark:after {
    display: block;
  }

  .container .checkmark:after {
    top: 9px;
    left: 9px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: white;
  }
  .on {
    color: ${({ theme }) => theme.colors.primary};
  }
  .img-center {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60%;
    margin-top: -20px;
    margin-left: 70px;
  }
  .active {
    background-color: ${({ theme }) => theme.colors.secondPrimary};
    color: ${({ theme }) => theme.colors.white};
    /* border: 5px solid ${({ theme }) => theme.colors.secondPrimary}; */
  }
  .plan-top {
    margin-top: -20px;
  }

  .description_wrapper {
    margin-top: 0px;
  }
  .description {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    /* background: red; */
  }
  .target {
    width: 100%;
  }
  .payment-top {
    margin-top: 40px;
  }
  .span {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    flex-direction: column;
  }
  span {
    margin-top: -10px;
    font-size: 12px;
  }
  .image {
    height: 40px;
    width: 70px;
    border-radius: 8px;
  }
  .card-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
  }
  .left {
    margin-left: 20px;
  }
  .card-center {
    display: flex;
    align-items: center;
  }
  .description_title {
    font-size: ${({ theme }) => theme.fontSize.x5};
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    color: ${({ theme }) => theme.colors.profileBlack};
  }
  .payment_section {
    margin-top: -15px;
  }
  .result {
    color: ${({ theme }) => theme.colors.navyBlue};
    font-weight: 600;
    font-size: 16px;
    line-height: 140%;
  }

  li {
    font-style: normal;
    font-size: 15px;
    letter-spacing: 0.75%;
    color: #09101d;
    margin: 15px;
  }
`
